import { render } from "./Plans.vue?vue&type=template&id=08e00dd1&scoped=true"
import script from "./Plans.vue?vue&type=script&lang=js"
export * from "./Plans.vue?vue&type=script&lang=js"

import "./Plans.vue?vue&type=style&index=0&id=08e00dd1&lang=scss&scoped=true"
import "./Plans.vue?vue&type=style&index=1&id=08e00dd1&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08e00dd1"]])

export default __exports__